import React from 'react'

import type { CardProps } from '@mui/material/Card'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardHeader from '@mui/material/CardHeader'
import Divider from '@mui/material/Divider'

interface InterviewCardProps extends CardProps {
    title: string
}

export default function InterviewCard({ title, children, style, ...props }: InterviewCardProps) {
    return (
        <Card style={{ marginTop: '25px', ...style }} {...props}>
            <CardHeader style={{ textAlign: 'center' }} title={title} titleTypographyProps={{ variant: 'h4' }} />
            <Divider />
            <CardContent style={{ minHeight: '150px' }}>{children}</CardContent>
        </Card>
    )
}
